import React, { useState } from 'react';
import './AddressFilters.css';

const AddressFilters = ({ onFilterChange, loading }) => {
  const [limit, setLimit] = useState(100);
  const [days, setDays] = useState(null);

  const handleApply = () => {
    onFilterChange({ limit, days });
  };

  return (
    <div className="address-filters">
      <div className="filter-group">
        <label>
          Max. Transaktionen:
          <select 
            value={limit} 
            onChange={(e) => setLimit(Number(e.target.value))}
            disabled={loading}
          >
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={200}>200</option>
            <option value={500}>500</option>
            <option value={1000}>1000</option>
          </select>
        </label>
      </div>

      <div className="filter-group">
        <label>
          Zeitraum:
          <select 
            value={days || ''} 
            onChange={(e) => setDays(e.target.value ? Number(e.target.value) : null)}
            disabled={loading}
          >
            <option value="">Alle</option>
            <option value={7}>Letzte 7 Tage</option>
            <option value={30}>Letzte 30 Tage</option>
            <option value={90}>Letzte 90 Tage</option>
            <option value={365}>Letztes Jahr</option>
          </select>
        </label>
      </div>

      <button 
        className="apply-filter-btn" 
        onClick={handleApply}
        disabled={loading}
      >
        Filter anwenden
      </button>
    </div>
  );
};

export default AddressFilters;
